import { IntegrationLogStatus, IntegrationLogVo, SortColDef } from "@/types";
import { formatToLATime } from "@/utils/date";
import { ICellRendererParams } from "ag-grid-community";
import { Tag } from "antd";
import { IntegrationLogStatusColorMap } from "./const";
import { noCheck } from "@/utils/shared";
import { ArrayParam, StringParam } from "use-query-params";
import { IntegrationLogTypeMap } from "./const";
import LinkColumn from "@/components/shared/LinkColumn";

export const IntegrationLogCols: SortColDef<IntegrationLogVo>[] = [
  {
    headerName: "Type",
    resizable: true,
    field: "type",
    maxWidth: 320,
    minWidth: 180,
    suppressMenu: true,
    cellRenderer: (row: ICellRendererParams<IntegrationLogVo, string>) => (
      <LinkColumn
        row={{
          ...row,
          value: IntegrationLogTypeMap[row.data!.type],
        }}
        getLink={() => window.location.href}
      />
    ),
    rowDrag: false,
  },
  {
    headerName: "Status",
    resizable: false,
    maxWidth: 100,
    minWidth: 100,
    suppressMenu: true,
    rowDrag: false,
    sortKey: "status",
    cellRenderer: ({ data }: ICellRendererParams<IntegrationLogVo, number>) => (
      <Tag color={IntegrationLogStatusColorMap[data!.status]}>
        {data!.status}
      </Tag>
    ),
  },
  {
    headerName: "Customer Order No.",
    field: "customerNumber",
    resizable: true,
    minWidth: 100,
    flex: 1,
    suppressMenu: true,
    rowDrag: false,
  },
  {
    headerName: "Created At",
    field: "createdAt",
    minWidth: 180,
    suppressMenu: true,
    sortKey: "created_at",
    initialSort: "desc",
    cellRenderer: ({ value }: ICellRendererParams<IntegrationLogVo, string>) =>
      value && formatToLATime(value),
  },
  {
    headerName: "Updated At",
    field: "updatedAt",
    minWidth: 180,
    suppressMenu: true,
    cellRenderer: ({ value }: ICellRendererParams<IntegrationLogVo, string>) =>
      value && formatToLATime(value),
  },
];

export const IntegrationLogTableSearchItems = [
  {
    title: "Customer Order No.",
    desc: "like search",
    span: 1,
    type: "text",
    key: "customerNumberLike",
    placeHolder: "customer order no., input to search",
    inputMode: "text",
    defaultValue: "" as string,
    pageQueryConfig: StringParam,
    validate: noCheck,
  },
  {
    title: "Type",
    desc: "multiple select",
    span: 2,
    type: "select",
    key: "typeList",
    mode: "multiple",
    options: Object.entries(IntegrationLogTypeMap).map(([key, value]) => ({
      label: value,
      value: key,
    })),
    placeHolder: "select log type",
    pageQueryConfig: ArrayParam,
    validate: noCheck,
  },
  {
    title: "Status",
    desc: "select",
    span: 1,
    type: "select",
    key: "status",
    options: [
      { label: "Success", value: IntegrationLogStatus.Success },
      { label: "Failed", value: IntegrationLogStatus.Failed },
    ],
    placeHolder: "select log status",
    pageQueryConfig: StringParam,
    validate: noCheck,
  },
];
